import { render, staticRenderFns } from "./ContactsListTable.component.vue?vue&type=template&id=bf4da9bc"
import script from "./ContactsListTable.component.vue?vue&type=script&lang=js"
export * from "./ContactsListTable.component.vue?vue&type=script&lang=js"
import style0 from "./ContactsListTable.component.vue?vue&type=style&index=0&id=bf4da9bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports